import request from '@/utils/request'
import { XssCommonPageListQuery, XssCommonPageListResult } from '@/types/public'
import {
  GetJijiaDeviceListResultItem,
  ConfirmBuyPrams,
  GetJijiaOrderListItem,
  ConfirmBuyJiaResult,
  OrderDetail,
  GetJijiaOrderListQuery,
  ApplyInvoiceParams,
} from '@/types/jijia'

export function getJijiaDeviceList(
  params: XssCommonPageListQuery
): Promise<GetJijiaDeviceListResultItem[]> {
  return request.get(`/api/applets/common/equipments/me`, {
    params: { ...params, models_type: 'xcare_extend_2022_model' },
  })
}

// 购买服务
export function confirmBuy(params: ConfirmBuyPrams): Promise<ConfirmBuyJiaResult> {
  return request.post('/api/applets/xcare/xcare_extend_order/buy_xcare', params)
}

// 极加服务订单列表
export function getJijiaOrderList(
  params: XssCommonPageListQuery & GetJijiaOrderListQuery
): Promise<XssCommonPageListResult<GetJijiaOrderListItem>> {
  return request.get(`/api/applets/xcare/xcare_extend_order`, {
    params: { ...params },
  })
}

// 获取极加服务订单详情
export function getJijiaOrderDetail(guid: string): Promise<OrderDetail> {
  return request.get(`/api/applets/xcare/xcare_extend_order/${guid}`)
}

// 申请发票
export function applyJijiaOrderInvoice(guid: string, params: ApplyInvoiceParams): Promise<void> {
  return request.post(`/api/applets/xcare/xcare_extend_order/${guid}/apply_invoice`, params)
}

// 重新验机
export function applyVerifyDevice(guid: string): Promise<void> {
  return request.post(`/api/applets/xcare/xcare_extend_order/${guid}/again_inspection`)
}
// 检查支付状态
export function checkPayOrderStatus(guid: string): Promise<{
  pay_status: number
}> {
  return request.get(`/api/applets/xcare/xcare_extend_order/${guid}/check_payment`)
}
// 获取设备详情
export function getJijiaDeviceDetail(guid: string): Promise<GetJijiaDeviceListResultItem> {
  return request.get(`/api/applets/common/equipments/${guid}`)
}
